<template>
  <v-dialog
    v-model="chatFilterDialog"
    transition="dialog-bottom-transition"
    max-width="500px"
  >
    <v-card v-if="filter">
      <v-toolbar
        dark
        flat
        color="secondary"
      >
        <v-btn
          icon
          dark
          @click.native="chatFilterDialog = false"
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>סינון צ׳אט</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          dark
          flat
          @click.native="clearFilter"
        >
          נקה סינון
        </v-btn>
        <v-btn
          dark
          flat
          
          @click.native="setFilter"
        >
          שמירה
        </v-btn>

      </v-toolbar>
      <v-form
        ref="form"
        lazy-validation
      >
        <v-layout
          row
          wrap
        >
          <v-flex>
            <v-card-text>
              <v-combobox
                v-model="filter.tags"
                :items="hashtags"
                label="כל התאגים"
                chips
                clearable
                solo
                multiple
              >
                <template v-slot:selection="data">
                  <v-chip
                    :selected="data.selected"
                    close
                    @input="removeTag(data.item)"
                  >
                    <strong>{{ data.item }}</strong>
                  </v-chip>
                </template>
              </v-combobox>
              <!-- Debug info -->
           
              <!-- Show current ARAN name -->
              <div v-if="isAllEventsMode && currentAranName" style="margin-bottom: 10px;">
                <span class="grey--text">אר"ן נוכחי:</span>
                <strong>{{ currentAranName }}</strong>
              </div>
              
              <v-combobox
                v-model="filter.event"
                :items="events"
                item-text="name"
                item-value="id"
                return-object
                label="אירוע"
                clearable
                solo
                v-if="isAllEventsMode"
              >
                <template v-slot:selection="data">
                  <v-chip
                    :selected="data.selected"
                    close
                    @input="removeEvent(data.item)"
                  >
                    <strong>{{ data.item.name }}</strong>
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <div>{{ data.item.name }}</div>
                </template>
              </v-combobox>
              <v-text-field
                type="text"
                v-model="filter.search"
                clearable
                label="מילת מפתח"
              ></v-text-field>
              <v-checkbox
                v-model="filter.hasAttachments"
                color="primary"
                label="קבצים מצורפים"
              ></v-checkbox>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { format } from "date-fns";
import { getApi } from "@/api";
import { cloneDeep } from "lodash";

export default {
  data() {
    return {
      filter: {}
    };
  },

  computed: {
    chatFilterDialog: {
      get() {
        return this.$store.getters["chats/chatFilterDialog"](this.compId);
      },
      set(val) {
        this.$store.commit("chats/SET_CHAT_FILTER_DIALOG", {
          val,
          compId: this.compId
        });
      }
    },
    hashtags() {
      return Object.values(this.$store.state.entities.hashtags).map(item => {
        return item.title;
      }) || [];
    },
    isAllEventsMode() {
      const eventIdsToShow = this.$store.getters["events/eventIdsToShow"];
      const showAllEvents = this.$store.getters["events/showAllEvents"];
      console.log('ChatFilterDialog isAllEventsMode - eventIdsToShow:', eventIdsToShow);
      console.log('ChatFilterDialog isAllEventsMode - showAllEvents:', showAllEvents);
      const result = showAllEvents && eventIdsToShow && eventIdsToShow.length > 1;
      console.log('ChatFilterDialog isAllEventsMode - result:', result);
      return result;
    },
    arans() {
      const arans = Object.values(this.$store.state.entities.arans).map(item => {
        return item.name;
      }) || [];
      console.log('ChatFilterDialog arans - available arans:', arans);
      return arans;
    },
    events() {
      // Get the current event's ARAN
      const currentEventId = this.$route.params.id;
      const currentEvent = this.$store.state.entities.events[currentEventId];
      let currentAranId = null;
      
      console.log('ChatFilterDialog events - currentEventId:', currentEventId);
      console.log('ChatFilterDialog events - currentEvent:', currentEvent);
      
      if (currentEvent && currentEvent.aran) {
        currentAranId = currentEvent.aran;
      }
      
      console.log('ChatFilterDialog events - currentAranId:', currentAranId);
      
      if (!currentAranId) {
        console.log('ChatFilterDialog events - no ARAN found, returning empty array');
        return [];
      }
      
      // Get all events that have the same ARAN
      const allEvents = Object.values(this.$store.state.entities.events);
      console.log('ChatFilterDialog events - allEvents count:', allEvents.length);
      
      const eventsInSameAran = allEvents
        .filter(event => {
          console.log('ChatFilterDialog events - checking event:', event._id, 'ARAN:', event.aran, 'matches:', event.aran === currentAranId);
          return event.aran === currentAranId;
        })
        .map(event => ({ id: event._id, name: event.title }))
        .filter(event => event !== null);
      
      console.log('ChatFilterDialog events - events in same ARAN:', eventsInSameAran);
      return eventsInSameAran;
    },
    currentAranName() {
      const currentEventId = this.$route.params.id;
      const currentEvent = this.$store.state.entities.events[currentEventId];
      
      if (currentEvent && currentEvent.aran) {
        const aran = this.$store.state.entities.arans[currentEvent.aran];
        return aran ? aran.name : null;
      }
      return null;
    }
  },

  methods: {
    clearFilter() {
      this.filter = {};
      this.setFilter();
    },
    setFilter() {
      if (
        !this.filter.search &&
        this.filter.hasAttachments !== true &&
        (!this.filter.tags || !this.filter.tags.length) &&
        !this.filter.event
      ) {
        this.filter = {};
      }
      this.$store.commit("chats/SET_CHAT_FILTER", {
        val: cloneDeep(this.filter),
        compId: this.compId
      });
      this.chatFilterDialog = false;
    },
    removeTag(item) {
      this.filter.tags.splice(this.filter.tags.indexOf(item), 1);
      this.filter.tags = [...this.filter.tags];
    },
    removeAran(item) {
      this.filter.aran = null;
    },
    removeEvent(item) {
      this.filter.event = null;
    }
  },

  watch: {
    chatFilterDialog: {
      handler: function(val) {
        if (val) {
          this.filter = cloneDeep(
            Object.assign({}, this.$store.getters["chats/filter"](this.compId))
          );
        } else {
          this.filter = {};
        }
      },
      immediate: true
    }
  },

  beforeMount() {},

  mounted() {},

  props: ["compId"]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/chat/ChatFilterDialog.vue